import { DeviceType } from "@/types/device.type";
import { useMediaQuery } from "react-responsive";

const useDevice = (mobile = 768, pc = 1025) => {
  const isMobile = useMediaQuery({
    query: `(max-width:${mobile}px)`,
  });
  const isTablet = useMediaQuery({
    query: `(min-width: ${mobile + 1}px) and (max-width: ${pc - 1}px)`,
  });
  const isPc = useMediaQuery({
    query: `(min-width:${pc}px)`,
  });

  const getDevice = () => {
    if (isMobile) return DeviceType.MO;
    else if (isTablet) return DeviceType.TABLET;
    return DeviceType.PC;
  };

  return { isMobile, isTablet, isPc, getDevice };
};

export default useDevice;
